// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StopTwoToneSvg from "@fishx/icons-svg/es/asn/StopTwoTone";
import FishxIcon from '../components/FishxIcon';

var StopTwoTone = function StopTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StopTwoToneSvg
  }));
};

StopTwoTone.displayName = 'StopTwoTone';
export default React.forwardRef(StopTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StopTwoTone.js
// module id = 4206
// module chunks = 0